const state = {
  routes: [],
  addRoutes: [],
  routesAdded: false
}

/** 侧栏只用 path/meta，绝不存 component，避免 Layout↔store 环引用爆栈 */
function toMenuRoutes(routes) {
  return (routes || []).map(route => {
    const item = {
      path: route.path,
      name: route.name,
      hidden: !!route.hidden,
      meta: route.meta ? { ...route.meta } : {}
    }
    if (typeof route.redirect === 'string') {
      item.redirect = route.redirect
    }
    if (route.children && route.children.length) {
      item.children = toMenuRoutes(route.children)
    }
    return item
  })
}

const mutations = {
  SET_ROUTES(state, routes) {
    const menus = toMenuRoutes(routes || [])
    state.addRoutes = Object.freeze(menus)
    state.routesAdded = true
    // 合并控制台常驻菜单（同样不含 component）
    const home = {
      path: '/',
      redirect: '/dashboard',
      meta: {},
      children: [{
        path: 'dashboard',
        name: 'Dashboard',
        meta: { title: '控制台', icon: 'el-icon-s-home', affix: true, permission: 'dashboard:view' }
      }]
    }
    const visible = menus.filter(r => {
      if (!r || r.hidden || (r.meta && r.meta.hidden)) return false
      if (r.path === '*' || r.path === '/404' || r.path === '/login') return false
      if (r.redirect && !r.children) return false
      return true
    })
    // freeze：禁止 Vue 观察菜单树，彻底杜绝 Layout↔store 环
    state.routes = Object.freeze([home].concat(visible))
  },
  RESET_ROUTES(state) {
    state.addRoutes = []
    state.routes = []
    state.routesAdded = false
  }
}

const actions = {
  generateRoutes({ commit }, routes) {
    commit('SET_ROUTES', routes)
    return routes
  },
  resetRoutes({ commit }) {
    commit('RESET_ROUTES')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
